// let loaded = false;
import Script from 'next/script';
import { useUserPrivacyConsent } from './../../redux/user/userHooks';

export const AdBlockerManager = () => {
  const consent = useUserPrivacyConsent();

  if (!consent.targeting) {
    return null;
  }

  return (
    <Script
      strategy="lazyOnload"
      id="ad-block-manager"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `
    !(function(o,n,t){t=o.createElement(n),o=o.getElementsByTagName(n)[0],t.async=0,t.defer=1,t.src="https://damageddistance.com/v2bhkDEZm9uXFBNyxb6P-JUykV7_E8wP2cAAXv1n25CJwsW-2hHYAR2b5",o.parentNode.insertBefore(t,o)})(document,"script"),(function(o,n){o[n]=o[n]||function(){(o[n].q=o[n].q||[]).push(arguments)}})(window,"admiral");!(function(c,e,o,t,n){function r(o,t){(function n(){try{return 0<(localStorage.getItem("v4ac1eiZr0")||"").split(",")[4]}catch(o){}return!1})()&&(t=c[e].pubads())&&t.setTargeting("ae","t")}(n=c[e]=c[e]||{}).cmd=n.cmd||[],typeof n.pubads===o?r():typeof n.cmd.unshift===o?n.cmd.unshift(r):n.cmd.push(r)})(window,"googletag","function");`
      }}
    />
  );
};
